import * as yup from "yup";
import { AmountTypeEnum } from "api";
import {
  PAYER_NAME_TOKEN,
  ORDER_NUMBER_TOKEN,
} from "shared/functions/ibanQrHelpers";

export type FormValues = {
  ibanAccountUid?: string | null;
  bankName?: string;
  organizationName: string;
  identificationCode: string;
  iban: string;
  publicName?: string;
  amount?: number;
  amountType: AmountTypeEnum;
  paymentPurpose: string;
  showNotes?: boolean;
  notes?: string;
  requestPayerFullName?: boolean;
  requestOrderNumber?: boolean;
  showClientNotes?: boolean;
  clientNotes?: string;
  showInvoiceExpiration?: boolean;
  expirationDays?: number;
  expirationHours?: number;
};

export const validationSchema = yup.object({
  organizationName: yup
    .string()
    .required("Вкажіть 'Юридичну назву компанії або ФОП'"),
  publicName: yup
    .string()
    .max(70, "'Публічна назва' має містити менше ніж 70 символів"),
  identificationCode: yup
    .string()
    .required("Вкажіть 'ЄДРПОУ/РНОКПП'")
    .min(8, "'ЄДРПОУ/РНОКПП' має містити 8 або більше символів")
    .max(13, "'ЄДРПОУ/РНОКПП' має містити менше ніж 13 символів"),
  iban: yup
    .string()
    .required("Вкажіть 'IBAN'")
    .min(29, "'IBAN' має містити 29 символів")
    .max(29, "'IBAN' має містити 29 символів")
    .matches(/^UA\d{2}\d{6}\d{5}\d{14}$/, "Неправильний формат 'IBAN'"),
  amount: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .when("amountType", {
      is: AmountTypeEnum.MerchantDefined,
      then: (schema) =>
        schema.moreThan(0, "Вкажіть 'Суму'").required("Вкажіть 'Суму'"),
      otherwise: (schema) => schema,
    }),
  amountType: yup
    .mixed<AmountTypeEnum>()
    .oneOf([AmountTypeEnum.MerchantDefined, AmountTypeEnum.PayerDefined], "")
    .required(""),
  paymentPurpose: yup
    .string()
    .max(140, "'Призначення платежу' має містити менше ніж 140 символів")
    .required("Вкажіть 'Призначення платежу'")
    .test(
      "payer-name-required",
      "Вимкніть налаштування «Запитувати Ім'я та прізвище» або додайте текст {{ім'я та прізвище клієнта}} до призначення платежу",
      function (value) {
        if (!this.parent.requestPayerFullName) return true;
        return value.includes(PAYER_NAME_TOKEN);
      },
    )
    .test(
      "payer-name-unexpected",
      "Увімкніть налаштування «Запитувати Ім'я та прізвище» або приберіть текст {{ім'я та прізвище клієнта}} з призначення платежу",
      function (value) {
        if (this.parent.requestPayerFullName) return true;
        return !value.includes(PAYER_NAME_TOKEN);
      },
    )
    .test(
      "order-number-required",
      "Вимкніть налаштування «Запитувати Номер замовлення» або додайте текст {{номер замовлення}} до призначення платежу",
      function (value) {
        if (!this.parent.requestOrderNumber) return true;
        return value.includes(ORDER_NUMBER_TOKEN);
      },
    )
    .test(
      "order-number-unexpected",
      "Увімкніть налаштування «Запитувати Номер замовлення» або приберіть текст {{номер замовлення}} з призначення платежу",
      function (value) {
        if (this.parent.requestOrderNumber) return true;
        return !value.includes(ORDER_NUMBER_TOKEN);
      },
    ),
});
